import PromineoMultiSelectDropdown from "components/common/controls/PromineoMultiSelectDropdown";
import DropdownValuesResponse from "interfaces/response/DropdownValuesResponse";
import FormGroup from "components/common/FormGroup";
import { EditorMode } from "shared/enums/EditorModeEnum";
import UserResponse from "interfaces/response/UserResponse";

interface Props {
  user?: UserResponse;
  dataSource?: DropdownValuesResponse[];
  mode: EditorMode;
  defaultValue: number[];
  handleChange: (e: any, fieldName: string) => void;
}

export default function RoleChooser(props: Props) {
  let userRoleFieldName = "roles";

  const { dataSource, handleChange, defaultValue } = props;

  return (
    <>
      <div className="col-span-2">
        <FormGroup label="User Role">
          <PromineoMultiSelectDropdown dataSource={dataSource}
            name="userRole"
            label="User Role"
            applyValueMode="instantly"
            displayExpr="name"
            valueExpr="value" 
            className="w-full"
            defaultValue={defaultValue}
            required={true}
            multiline={false}
            onValueChange={(e) => {
              handleChange(e, userRoleFieldName);
            }}
          />
        </FormGroup>
      </div>
    </>
  )
}

